import { Button, Flex, Tooltip } from 'antd';
import { tooltipTexts } from '../../utility';

export function WaveBulkToolbar({
  selectedCount,
  canWavesBeMerged,
  wavesWithUsersCount,
  onMerge,
  onAssignPicker,
  onUnassignPicker,
}) {
  if (selectedCount < 1) {
    return null;
  }

  const mergeButton = (
    <Button disabled={selectedCount < 2 || !canWavesBeMerged} onClick={onMerge}>
      Merge Waves
    </Button>
  );

  return (
    <Flex align="center" gap={8} wrap="nowrap">
      {canWavesBeMerged ? (
        mergeButton
      ) : (
        <Tooltip title={tooltipTexts.waveTypeMerging}>
          <span>
            <Button disabled>Merge Waves</Button>
          </span>
        </Tooltip>
      )}
      <Button onClick={onAssignPicker}>Assign Picker</Button>
      <Button disabled={wavesWithUsersCount < 1} onClick={onUnassignPicker}>
        Un Assign Picker
      </Button>
    </Flex>
  );
}
